<template>
  <el-dialog
    :title="model.id ? `编辑出库单` : `添加出库单`"
    :visible.sync="visible"
    width="600px"
    :close-on-click-modal="false"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="90px"
      size="small"
    >
      <el-form-item label="数据月份" prop="belong_month">
        <el-select
          class="long"
          v-model="model.belong_month"
          :disabled="model.id"
        >
          <el-option label="本月" :value="1" key="1"></el-option>
          <el-option label="上月" :value="2" key="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="部门" prop="department">
        <ParamsSelect
          v-model="model.department"
          paramName="department"
          table="outbound_orders"
        ></ParamsSelect>
      </el-form-item>
      <el-form-item label="出库类型" prop="category">
        <el-select v-model="model.category" style="width: 100%" disabled>
          <el-option
            v-for="(value, index) in ItemStockOutCategoryMap"
            :key="index"
            :label="value"
            :value="parseInt(index)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="新 / 旧" prop="category">
        <el-select v-model="model.category" style="width: 100%" disabled>
          <el-option key="1" label="新" :value="1"></el-option>
          <el-option key="2" label="旧" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="钻头序列号"
        prop="drills"
        v-if="model.category == 1 && model.belong_month == 1"
      >
        <DrillSelect
          v-model="model.drills"
          v-if="visible && model.created"
        ></DrillSelect>
      </el-form-item>
      <el-form-item label="记账人">
        <ParamsSelect
          v-model="model.bookkeeper"
          paramName="bookkeeper"
          table="outbound_orders"
        ></ParamsSelect>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="model.remark" type="textarea"></el-input>
      </el-form-item>
      <el-form-item class="mb-0">
        <el-button size="small" type="primary" @click="submitForm"
          >确 定</el-button
        >
        <el-button size="small" @click="visible = false">取 消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { outboundOrderNew, outboundOrderUpdate } from '@/service/getData'
import ParamsSelect from './ParamsSelect.vue'
import { ItemStockOutCategoryMap } from '@/config/global'
import DrillSelect from '@/components/select/drill_multiple_select'

export default {
  components: {
    ParamsSelect,
    DrillSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      ItemStockOutCategoryMap,
      rules: {
        number: [{ required: true, message: '请填写编号', trigger: 'blur' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          data.drill_serial_numbers = data.drills.join(',')
          if (this.model.id > 0) {
            let res = await outboundOrderUpdate(data)
            if (res.code == 0) {
              this.$emit('callback', res.data)
              this.visible = false
            }
          } else {
            let res = await outboundOrderNew(data)
            if (res.code == 0) {
              this.$emit('callback', res.data)
              this.visible = false
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>